import BigNumber from "bignumber.js";

export function computeMonetaryWeight(effectiveWeight: number, aum: number | null): number {
	if (!aum) return 0;
	return BigNumber(effectiveWeight).div(100).times(aum).dp(2, BigNumber.ROUND_HALF_UP).toNumber();
}
